export default __webpack_public_path__ + "static/media/logofinal.186bd4a8.png";